require('./dynamicDataItemCriterion.i18n.json');
require('./dynamicDataItemCriterion.tpl.html');
require('./dynamicDataItemCriterionController.js');
require('./uiDeleteDynamicCriteriaDirective.js');

const DynamicDataItemCriterionComponent = {
    templateUrl: '/configuration/dataSetEditor/content/dynamicCriteria/dynamicDataItemCriterion/dynamicDataItemCriterion.tpl.html',
    controller: 'dynamicDataItemCriterionController',
    bindings: {
        datasetName: '<'
    }
};

angular.module('ums.configuration')
    .component('dynamicDataItemCriterion', DynamicDataItemCriterionComponent);
